import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
  Button,
  Checkbox,
} from "@chakra-ui/react";
import { useEffect, useRef } from "react";

interface Permission {
  id: number;
  name: string;
  guard_name: string;
  role: string;
  created_at: string;
  updated_at: string;
}

type Props = {
  isOpen: boolean;
  onClose: () => void;
  permissions?: Permission[];
  advSelectedIds?: any;
  setAdvSelectedIds?: any;
  setBasicSelectedIds?: any;
};

const AdvancedModal = ({ isOpen, onClose, permissions, advSelectedIds, setAdvSelectedIds, setBasicSelectedIds }: Props) => {
  const userRef = useRef(null);

  const transformName = (name: string) => {
    return name
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const advancedClose = () => {
    onClose()
    setBasicSelectedIds([])
  }

  const handleCheckboxChange = (id: number) => {
    setAdvSelectedIds((prevSelectedIds: any) => {
      const updatedSet = new Set(prevSelectedIds);
      if (updatedSet.has(id)) {
        updatedSet.delete(id);
      } else {
        updatedSet.add(id);
      }
      return Array.from(updatedSet);
    });
  };

  useEffect(() => {
    const viewDashboardPermissionId = permissions?.find(permission => permission?.id === 9)?.id;
    if (viewDashboardPermissionId && !advSelectedIds?.includes(viewDashboardPermissionId)) {
      setAdvSelectedIds((prevSelectedIds: any) => {
        const updatedSet = new Set([...prevSelectedIds, viewDashboardPermissionId]);
        return Array.from(updatedSet);
      });
    }
  }, [permissions, setAdvSelectedIds, advSelectedIds]);

  return (
    <Modal
      size="xl"
      finalFocusRef={userRef}
      isOpen={isOpen}
      onClose={advancedClose}
      isCentered={true}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
            <Box>
              <Text
                fontSize={`1.3rem`}
                fontWeight={`bold`}
                marginBottom={`2rem`}
                marginTop={`2rem`}
              >
                Add new Admin - Advanced
              </Text>
              <Box>
                <Text
                  fontSize={`1rem`}
                  fontWeight={`w500`}
                  marginBottom={`2rem`}
                >
                  Select access areas
                </Text>
                <Box
                  display={`grid`}
                  gridTemplateColumns={`repeat(2, 1fr)`}
                  marginBottom={`4rem`}
                  gap={`2rem`}
                >
                  {permissions?.map((permission: any) => (
                    <Checkbox
                      key={permission.id}
                      isChecked={advSelectedIds?.includes(permission?.id)}
                      onChange={() => handleCheckboxChange(permission?.id)}
                      fontWeight="600"
                    >
                      {transformName(permission?.name)}
                    </Checkbox>
                  ))}
                </Box>

                <Button
                  color={`#fff`}
                  backgroundColor={`#00473C`}
                  width={`100%`}
                  borderRadius={`.5rem`}
                  marginBottom={`1rem`}
                  onClick={advancedClose}
                >
                  Add new admin
                </Button>
              </Box>
            </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AdvancedModal;
